export const Country_list = [
    [0, "Australia"],
    [1, "Austria"],
    [2, "Belgium"],
    [3, "Bulgaria"],
    [4, "Croatia"],
    [5, "Czech"],
    [6, "Denmark"],
    [7, "Finland"],
    [8, "France"],
    [9, "Germany"],
    [10, "Greece"],
    [11, "Hungary"],
    [12, "Italy"],
    [13, "Luxembourg"],
    [14, "Netherland"],
    [15, "Norway"],
    [16, "Poland"],
    [17, "Portugal"],
    [18, "Rumania"],
    [19, "Russia"],
    [20, "Serbia"],
    [21, "Slovenia"],
    [22, "Spain"],
    [23, "Sweden"],
    [24, "Switzerland"],
    [25, "UK"],
    [26, "New Zealand"],
    [27, "Arab"],
    [28, "Estonia"],
    [29, "Hebrew"],
    [30, "Latvia"],
    [31, "Slovakia"],
    [32, "Turkey"],
    [33, "Ireland"],
    [34, "Japan"],
    [35, "Philippines"],
    [36, "Thailand"],
    [37, "Maldives"],
    [38, "Uruguay"],
    [39, "Peru"],
    [40, "Argentina"],
    [41, "Chile"],
    [42, "Venezuela"],
    [43, "Ecuador"],
    [44, "Costarica"],
    [45, "Paraguay"],
    [46, "Bolivia"],
    [47, "Belize"],
    [48, "Nicaragua"],
    [49, "Guatemala"],
    [50, "China"],
    [51, "Taiwan"],
    [52, "Brazil"],
    [53, "Canada"],
    [54, "Mexico"],
    [55, "United States"],
    [56, "South Korea"],
    [57, "romania"],
    [58, "Vietnam"],
    [59, "Ukraine"],
    [60, "Iran"],
    [61, "Iraq"],
    [62, "Burma"],
    [63, "Kazakstan"],
    [64, "Uzbekistan"],
    [65, "Tajikstan"],
    [66, "Kyrgyzstan"],
    [67, "Algeria"],
    [68, "Egypt"],
    [69, "Tunisia"],
    [70, "Tanzania"],
    [71, "Kenya"],
    [72, "Pakistan"],
    [73, "Indonesia"],
    [74, "Kuwait"],
    [75, "Saudi Arabia"],
    [76, "Qatar"],
    [77, "Israel"],
    [78, "Lebanon"],
    [79, "Hahrain"],
    [80, "Angola"],
    [81, "Congo"],
    [82, "India"],
    [83, "Turkmenistan"],
    [84, "Colombia"],
    [85, "Mongolia"],
    [86, "Bangladesh"],
    [87, "Nepal"],
    [88, "Sri lanka"],
    [89, "North Korea"],
    [90, "Moldova"],
    [91, "Polynesia"],
    [92, "Salvado"],
    [93, "Hongkong"],
    [94, "Fiji"],
    [95, "Liberia"],
    [96, "Jordan"],
    [97, "Myanmar"],
    [98, "Ghana"],
    [99, "Georgia"],
    [100, "Armenia"],
];

export const Country_shortName_list = [
    ["AU", "Australia"],
    ["AT", "Austria"],
    ["BE", "Belgium"],
    ["BG", "Bulgaria"],
    ["HR", "Croatia"],
    ["CS", "Czech"],
    ["DK", "Denmark"],
    ["FI", "Finland"],
    ["FR", "France"],
    ["DE", "Germany"],
    ["GR", "Greece"],
    ["HU", "Hungary"],
    ["IT", "Italy"],
    ["LU", "Luxembourg"],
    ["NL", "Netherland"],
    ["NO", "Norway"],
    ["PL", "Poland"],
    ["PT", "Portugal"],
    ["RO", "Rumania"],
    ["RU", "Russia"],
    ["", "Serbia"],
    ["SI", "Slovenia"],
    ["ES", "Spain"],
    ["SE", "Sweden"],
    ["CH", "Switzerland"],
    ["GB", "UK"],
    ["NZ", "New Zealand"],
    ["AE", "Arab"],
    ["EE", "Estonia"],
    ["", "Hebrew"],
    ["LV", "Latvia"],
    ["SK", "Slovakia"],
    ["TR", "Turkey"],
    ["IE", "Ireland"],
    ["JP", "Japan"],
    ["PH", "Philippines"],
    ["TH", "Thailand"],
    ["MV", "Maldives"],
    ["UY", "Uruguay"],
    ["PE", "Peru"],
    ["AR", "Argentina"],
    ["CL", "Chile"],
    ["VE", "Venezuela"],
    ["EC", "Ecuador"],
    ["CR", "Costarica"],
    ["PY", "Paraguay"],
    ["BO", "Bolivia"],
    ["BZ", "Belize"],
    ["NI", "Nicaragua"],
    ["GT", "Guatemala"],
    ["CN", "China"],
    ["TW", "Taiwan"],
    ["BR", "Brazil"],
    ["CA", "Canada"],
    ["MX", "Mexico"],
    ["US", "United States"],
    ["KR", "South Korea"],
    ["RO", "romania"],
    ["VN", "Vietnam"],
    ["UA", "Ukraine"],
    ["IR", "Iran"],
    ["IQ", "Iraq"],
    ["", "Burma"],
    ["KZ", "Kazakstan"],
    ["UZ", "Uzbekistan"],
    ["TJ", "Tajikstan"],
    ["KG", "Kyrgyzstan"],
    ["DZ", "Algeria"],
    ["EG", "Egypt"],
    ["TN", "Tunisia"],
    ["TZ", "Tanzania"],
    ["KE", "Kenya"],
    ["PK", "Pakistan"],
    ["ID", "Indonesia"],
    ["KW", "Kuwait"],
    ["SA", "Saudi Arabia"],
    ["QA", "Qatar"],
    ["IL", "Israel"],
    ["LB", "Lebanon"],
    ["", "Hahrain"],
    ["AO", "Angola"],
    ["CG", "Congo"],
    ["IN", "India"],
    ["TM", "Turkmenistan"],
    ["CO", "Colombia"],
    ["MN", "Mongolia"],
    ["BD", "Bangladesh"],
    ["NP", "Nepal"],
    ["LK", "Sri lanka"],
    ["KP", "North Korea"],
    ["MD", "Moldova"],
    ["PF", "Polynesia"],
    ["SV", "Salvado"],
    ["HK", "Hongkong"],
    ["FJ", "Fiji"],
    ["LR", "Liberia"],
    ["JO", "Jordan"],
    ["MM", "Myanmar"],
    ["GH", "Ghana"],
    ["GE", "Georgia"],
    ["AM", "Armenia"],
];




//////////////////
// WEBPACK FOOTER
// ./src/locale/country_list.js
// module id = null
// module chunks = 